import { canv } from '@/canv/global.js'

export class shapeHexagon {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 2/3 - 2 * horizontalPadding;
        var allowedHeight = height * 2/3 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height/2);
        canv.ctx.lineTo(x + width/4, y);
        canv.ctx.lineTo(x + width*3/4, y);
        canv.ctx.lineTo(x + width, y + height/2);
        canv.ctx.lineTo(x + width*3/4, y + height);
        canv.ctx.lineTo(x + width/4, y + height);
        canv.ctx.lineTo(x, y + height/2);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="92" height="80" viewBox="0 0 92 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.6716 0.535991L0.243051 39.536C0.0908267 39.8266 0.0908271 40.1734 0.243052 40.464L20.6716 79.464C20.8442 79.7935 21.1855 80 21.5575 80H67.9911C68.35 80 68.6813 79.8077 68.8594 79.4961L91.1451 40.4961C91.3207 40.1887 91.3207 39.8113 91.1451 39.5039L68.8594 0.503861C68.6813 0.192286 68.35 0 67.9911 0H21.5575C21.1855 0 20.8442 0.206475 20.6716 0.535991Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.90674 1.53599L1.24305 12.3485C1.09083 12.6391 1.09083 12.9859 1.24305 13.2765L6.90674 24.089C7.07935 24.4185 7.42059 24.625 7.79257 24.625H20.6697C21.0285 24.625 21.3599 24.4327 21.5379 24.1211L27.7165 13.3086C27.8922 13.0012 27.8922 12.6238 27.7165 12.3164L21.5379 1.50386C21.3599 1.19229 21.0285 1 20.6697 1H7.79257C7.42059 1 7.07935 1.20648 6.90674 1.53599Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
